import API from "./config";
import { mapResponse, printError } from "../utils/mapResponse";
import axios from "axios";
/**
 *  @module Admin service
 */
export default {
  /**
   * API call to import users (.csv)
   * @param {object} payload - payload object
   * @param {string} payload.file - Base64 file (.csv)
   * @param {(string|null)} payload.password - user default password
   * @param {(number|null)} payload.account - default account id
   * @param {string} payload.notes - notes
   * @param {(string | null)} payload.expiring - default expiring time (ISO)
   * @param {boolean} payload.active - active user flag
   * @returns {Promise<Response>} Parsed response json
   */
  // NOT USED?!?
  /*
  IMPORT_USERS(payload) {
    return axios
      .get(API.usersImportURL, payload)
      .then(mapResponse)
      .catch(printError);
  },
  */

  /**
   * API call to reset password
   * @param {object} payload - payload object
   * @param {number} payload.id - user id
   * @param {string} payload.password - password
   * @returns {Promise<Response>} Fetch response, status 200 if success
   */

  RESET_PASSWORD(payload) {
    const { id, ...result } = payload;
    return axios.post(API.changePasswordURL + id, result);
  },

  SET_USER_ACCESS(id, data) {
    return axios
      .patch(`${API.generalUsersServices}${id}/state`, data)
      .then(mapResponse)
      .catch(printError);
  },

  GET_USER_ACCESS_CARD_HISTORY(userId) {
    return axios
      .get(`${API.generalUsersServices}/cards/${userId}`)
      .then(mapResponse)
      .catch(printError);
  },

  SET_USER_ACCESS_CARD(id, hasCard) {
    return (
      axios
        // .post(`${API.baseUrl}users/${id}/state`, { hasCard })
        .post(`${API.generalUsersServices}${id}/state`, { hasCard })
        .then(mapResponse)
        .catch(printError)
    );
  },

  /**
   * API call to get GDPR inforamtion
   * @param {boolean} isDownload - flag for download result
   * @returns {(object|GDPR)} returns BLob obj if flag is Download true,
   *  and GDPR object if the flag is false
   */

  GET_GDPR() {
    // TODO: fix download option
    return axios.get(`${API.getGDPRURL}`).then(mapResponse).catch(printError);
  },

  /**
   * API call to get settings of current user
   * @returns {Record<string, string | boolean | number>} object with jwt token if success,
   */

  GET_USER_SETTINGS() {
    return axios.get("/services/api/v2/users/usersettings");
  },

  /**
   * API call post an update to the users setting
   * @param {Record<string, string | boolean | number>} payload - payload object conatining the settings update.
   */

  PUT_USER_SETTINGS(payload) {
    return axios.put("/services/api/v2/users/usersettings", payload);
  },
};
